import { Component } from '@angular/core';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';

@Component({
  selector: 'app-cbs-guide',
  templateUrl: './cbs-guide.component.html',
  styleUrls: ['./cbs-guide.component.scss']
})
export class CbsGuideComponent {

  constructor(
    public dialogRef: MdbModalRef<CbsGuideComponent>,
  ){}

  close(){
    const result = true;
    this.dialogRef.close(result);
  }

}
